<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-07 10:35:06
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-06 19:29:49
-->
<template>
	<div class="library_details">
		<shop-details :shopDetailObj="shopDetailObj"></shop-details>
		<!-- 商品底部按钮 -->
		<div class="footer-btn">
			<p v-if="shopDetailObj.promote_status != promoteStatus.open" class="cor-FA8F14 tips flex flex-just-center flex-align-center">
				暂停推广的商品无法推荐给达人，若要将该商品推荐给达人，请联系{{ zsName }}开启推广
			</p>
			<div class="flex flex-just-center flex-align-center bottom">
				<el-tooltip
					:content="$isSp(platformId) ? '视频号暂未开放' : '请先选择商品'"
					:disabled="$isSp(platformId) ? false : !!selectionShopArr.length"
					placement="top"
				>
					<el-button @click="recommend" type="primary" v-if="$auth.hasPermi('system:goods:promote')" :disabled="$isSp(platformId)">
						推荐商品给达人
					</el-button>
				</el-tooltip>
				<el-button
					v-if="$auth.hasPermi('system:view-uploadHandCard') && !shopDetailObj.hand_card"
					type="primary"
					plain
					@click="lookHangCard"
					:disabled="!shopDetailObj.is_self"
				>
					上传手卡
				</el-button>
				<el-button type="primary" plain @click="lookHangCard" :disabled="!shopDetailObj.hand_card">查看手卡</el-button>
				<el-button type="primary" @click="copyBtnFun(shopDetailObj)" v-if="$isKs(shopDetailObj.platform_id)">复制商品ID</el-button>
				<el-tooltip class="item" :disabled="$isSp()" effect="dark" :content="content" placement="top" v-else>
					<el-button type="primary" @click="copyBtnFun(shopDetailObj)">复制商品链接</el-button>
				</el-tooltip>
			</div>
		</div>
		<handCard-dialog ref="handCardDialog" @refreshList="refreshList"></handCard-dialog>
		<recommendDrawer ref="recommendDrawer" :platformId="shopDetailObj.platform_id"></recommendDrawer>
	</div>
</template>
<script>
import shopDetails from '@/views/common/shopDetails';
import { shopDetail, syncProductSkuList } from '@/api/shopManage';
import handCardDialog from '@/views/shopManage/components/handCardDialog.vue';
import recommendDrawer from '@/views/shopManage/components/recommendDrawer';
import { copyFun } from '@/utils/common';
import { mapGetters } from 'vuex';
import { promoteStatus, zsRoleType, drRoleType } from '@/utils/dataMap';
export default {
	components: {
		shopDetails,
		recommendDrawer,
		handCardDialog,
	},
	computed: {
		...mapGetters(['isDarenPartner']),
		drName() {
			return drRoleType.name;
		},
		content() {
			// 保持不变
			return this.isDarenPartner
				? this.shopDetailObj.source_type === '2'
					? '专属链接，达人使用该链接带货产生的订单归属为您的业绩。'
					: '该链接非团长商品链接，达人使用该链接(托管商品链接除外)带货产生的订单无法统计到团队业绩。'
				: `非专属链接，达人使用该链接带货产生的订单无法归属到${this.drName}。请前往${this.drName}账号复制专属链接。`;
		},
		zsName() {
			return zsRoleType.name;
		},
	},
	name: 'library_details',
	data() {
		return {
			productId: '',
			thirdProductId: '',
			platformId: '',
			shopDetailObj: {},
			selectionShopArr: [],
			promoteStatus,
		};
	},
	async created() {
		this.productId = this.$route.query.productId;
		this.thirdProductId = this.$route.query.thirdProductId;
		this.platformId = this.$route.query.platformId;
		await this.asyncSkuList();
		this.getShopDetail();
	},
	methods: {
		async getShopDetail() {
			const { code, data } = await shopDetail({ product_id: this.productId });
			if (code == 0) {
				this.shopDetailObj = data;
				this.selectionShopArr = [this.shopDetailObj];
			}
		},
		async asyncSkuList() {
			// 同步商品sku， 抖音更改了同步sku的限额，所以只能按需同步，使用哪个商品就调用同步哪个sku
			await syncProductSkuList({
				platformId: this.platformId,
				productIds: [
					{
						outProductId: this.thirdProductId,
						productId: this.productId,
					},
				],
				source: dataMap.syncSkuSource.detail_pc,
			});
		},
		lookHangCard() {
			this.shopDetailObj.hand_card
				? this.$refs.handCardDialog.seeHandCard(this.shopDetailObj)
				: this.$refs.handCardDialog.handCard(this.shopDetailObj);
		},
		copyBtnFun(row) {
			copyFun(row, this);
		},
		refreshList() {
			this.$router.go(0);
		},
		recommend() {
			if (!this.selectionShopArr.length) return;
			let arr = JSON.parse(JSON.stringify(this.selectionShopArr));
			this.$refs.recommendDrawer.show(arr, 1);
		},
	},
};
</script>
<style lang="less" scoped>
.footer-btn {
	width: 100%;
	position: fixed;
	bottom: 0;
	left: 0;
	background-color: #fff;

	div {
		padding: 12px 0;
	}
}

.tips {
	height: 40px;
	font-size: 14px;
	background-color: #fef3e7;
}

.cor-FA8F14 {
	color: #fa8f14;
}

.bottom {
	border: 1px solid #f8f8f8;
}
</style>
